import React from 'react'

export const DMSidebarIcon = ({ isActive }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 20.75H7C6.86614 20.75 6.75 20.6339 6.75 20.5C6.75 20.3661 6.86614 20.25 7 20.25H17C18.5035 20.25 19.7174 19.8847 20.5511 19.0511C21.3847 18.2174 21.75 17.0035 21.75 15.5V8.5C21.75 6.99651 21.3847 5.78256 20.5511 4.94895C19.7174 4.11533 18.5035 3.75 17 3.75H7C5.49651 3.75 4.28256 4.11533 3.44895 4.94895C2.61533 5.78256 2.25 6.99651 2.25 8.5C2.25 8.63386 2.13386 8.75 2 8.75C1.86614 8.75 1.75 8.63386 1.75 8.5C1.75 6.76991 2.24598 5.47362 3.1098 4.6098C3.97362 3.74598 5.26991 3.25 7 3.25H17C18.7301 3.25 20.0264 3.74598 20.8902 4.6098C21.754 5.47362 22.25 6.76991 22.25 8.5V15.5C22.25 17.2301 21.754 18.5264 20.8902 19.3902C20.0264 20.254 18.7301 20.75 17 20.75Z"
      fill="white"
      stroke={isActive ? '#FFFFFF' : '#2D264B'}
    />
    <path
      d="M11.9998 12.87C11.1598 12.87 10.3098 12.61 9.65978 12.08L6.52978 9.57997C6.20978 9.31997 6.14978 8.84997 6.40978 8.52997C6.66978 8.20997 7.13977 8.14997 7.45977 8.40997L10.5898 10.91C11.3498 11.52 12.6398 11.52 13.3998 10.91L16.5298 8.40997C16.8498 8.14997 17.3298 8.19997 17.5798 8.52997C17.8398 8.84997 17.7898 9.32997 17.4598 9.57997L14.3298 12.08C13.6898 12.61 12.8398 12.87 11.9998 12.87Z"
      stroke={isActive ? '#FFFFFF' : '#2D264B'}
    />
    <path
      d="M8 17.25H2C1.59 17.25 1.25 16.91 1.25 16.5C1.25 16.09 1.59 15.75 2 15.75H8C8.41 15.75 8.75 16.09 8.75 16.5C8.75 16.91 8.41 17.25 8 17.25Z"
      stroke={isActive ? '#FFFFFF' : '#2D264B'}
    />
    <path
      d="M5 13.25H2C1.59 13.25 1.25 12.91 1.25 12.5C1.25 12.09 1.59 11.75 2 11.75H5C5.41 11.75 5.75 12.09 5.75 12.5C5.75 12.91 5.41 13.25 5 13.25Z"
      stroke={isActive ? '#FFFFFF' : '#2D264B'}
    />
  </svg>
)
